<template>
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table content-table-striped table-hover table-h">
          <thead>
            <tr class="row global-thead-dark rounded-top">
              <th
                v-for="(column, i) in columns"
                :key="i"
                class="col-2 bold"
                v-text="column.text"
              />
              <th class="col-1" />
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, i) in documentsDisplay" :key="i" class="row">
              <td
                v-for="(column, j) in columns"
                :key="j"
                :class="[
                  j === columns.length - 1 ? 'col' : 'col-2',
                  j === 0 ? 'pl-4 ml-2' : 'pl-4',
                ]"
              >
                <span v-text="document[column.name]" />
              </td>
              <td class="col-1 ml-auto">
                <div class="dropdown float-right">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item cursor-pointer"
                      href="javascript:void(0)"
                      @click="downloadDocument(i)"
                    >
                      <em class="fas text-green fa-file-download mr-1" />
                      Descargar
                    </a>
                    <a
                      class="dropdown-item cursor-pointer"
                      href="javascript:void(0)"
                      @click="removeDocument(i)"
                    >
                      <em class="fas text-red fa-times-circle mr-1" />
                      Eliminar
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-12">
      <lazy-add-document
        :allowed-files="allowedFiles"
        :document-types="documentTypes"
        :added-document-type-ids="addedDocumentTypeIds"
        :prevent-duplicated-types="preventDuplicatedTypes"
        :fields="columns"
        @add="addDocument"
      />
    </div>
  </div>
</template>

<script>
import LazyAddDocument from './LazyAddDocument';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'LazyDocuments',
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [
        { text: 'Documento', name: 'type', active: true },
        { text: 'Archivo', name: 'file', active: true },
      ],
    },
    documentTypes: {
      type: Array,
      default: () => [
        { id: 1, name: 'Evaluación' },
        { id: 2, name: 'Minuta' },
      ],
    },
    preventDuplicatedTypes: {
      type: Array,
      default: () => [],
    },
    allowedFiles: {
      type: String,
      default: '.pdf',
    },
  },
  computed: {
    documentsDisplay() {
      return this.documents.map((document) => ({
        type: document.type.name,
        file: document.file.name,
      }));
    },
    addedDocumentTypeIds() {
      return this.documents.map((document) => document.type.id);
    },
  },
  methods: {
    addDocument(document) {
      this.documents.push(document);
      this.$emit('document-added');
    },
    downloadDocument(index) {
      const file = this.documents[index].file;
      const url = window.URL.createObjectURL(new Blob([file]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file.name);
      document.body.appendChild(link);
      link.click();
    },
    removeDocument(index) {
      let question = '¿Está seguro que desea eliminar el documento?';
      let self = this;
      self.ShowCancelModal('Alerta', question, 'Sí', 'No').then((response) => {
        if (response) {
          self.documents.splice(index, 1);
          self.$emit('document-removed');
          self.ShowToast(
            'Aviso',
            'El documento fue eliminado con éxito',
            'success'
          );
        }
      });
    },
  },
  components: {
    LazyAddDocument,
  },
  mixins: [alert],
};
</script>
